import React from 'react'
import './showcase.scss'

function ShowCore({ type, imguri, children }) {
  const showimg = <img className="showimg" src={imguri}></img>
  const section = <div className={`show_core_section show_core_section_${type}`}>{children}</div>
  const content = type == 'left' ? [showimg, section] : [section, showimg]
  const mobile_content = [showimg, section]
  return <div className="show_core_container">
    <div className="pc_container" >
      {content}
    </div>
    <div className="mobile_container">
      {mobile_content}
    </div>
  </div>
}

export default ShowCore